module.exports = __webpack_public_path__ + "34bc775d/img/copy-icon.408fdb2d.svg";